// Time constants
export const TIME_CONSTANTS = {
  // Working hours
  WORK_START_TIME: '09:00',
  WORK_END_TIME: '18:00',
  LUNCH_START_TIME: '12:00',
  LUNCH_END_TIME: '13:00',
  
  // Time slots for schedule calculations
  AM1_START: '09:00',
  AM1_END: '10:30',
  AM2_START: '10:30',
  AM2_END: '12:00',
  PM1_START: '13:00',
  PM1_END: '15:30',
  PM2_START: '15:30',
  PM2_END: '18:00',
  
  // Overrun and overtime thresholds
  OVERRUN_START: '12:00',
  OVERRUN_END: '12:50',
  OVERTIME_START: '18:00',
  
  // Saturday-specific time slots
  SATURDAY_AM2_END: '13:00', // Extended morning slot until 1:00 PM
  SATURDAY_OT_START: '13:15', // OT starts at 1:15 PM on Saturday
  
  // Default durations (in minutes)
  DEFAULT_APPOINTMENT_DURATION: 30,
  DEFAULT_TASK_DURATION: 60,
  
  // Layout stabilization delay (in milliseconds)
  LAYOUT_STABILIZATION_DELAY: 200,
} as const;

// Image/Canvas constants
export const IMAGE_CONSTANTS = {
  // A4 landscape dimensions at 150 DPI (optimized for wide tables)
  A4_WIDTH: 4960, // 11.69 inches * 150 DPI
  A4_HEIGHT: 1754, // 8.27 inches * 150 DPI
  
  // Image export settings
  CANVAS_PADDING: 80, // 80px padding on all sides
  IMAGE_QUALITY: 0.9, // PNG quality setting
  
  // Background colors
  DEFAULT_BACKGROUND: '#ffffff',
} as const;

// UI constants
export const UI_CONSTANTS = {
  // Default location (can be made configurable later)
  DEFAULT_LOCATION: 'Forum',
  
  // Table cell height
  TABLE_CELL_HEIGHT: '8', // Tailwind class value (h-8)
  
  // Modal max width
  MODAL_MAX_WIDTH: '90vw',
} as const;

// Validation constants
export const VALIDATION_CONSTANTS = {
  // Minimum input values
  MIN_DURATION: 0,
  MIN_ESTIMATED_DURATION: 0,
} as const;